import {
  GenerateLoadingOrError,
} from "@/lib/utils";
import {
  useListGeneralContracts,
  useListLocations,
  useListMarketZones,
} from "@/lib/api/generalContract";
import { useListTraders } from "@/lib/api/trader";
import { useListCustomers } from "@/lib/api/customer";
import { GeneralContractContent } from "./components/GeneralContractContent";
import { useSortFilterState } from "./shared/useGeneralContractState";

export function ContractsGeneralDashboard() {
  const sortFilterOptions = useSortFilterState((state: any) => ({
    sorting: state.sorting,
    filters: state.filters,
  }));
  const locationRes = useListLocations();
  const marketZoneRes = useListMarketZones();
  const customersResult = useListCustomers();
  const listTradersRes = useListTraders();

  const contractsRes = useListGeneralContracts(sortFilterOptions);
  const stagedContractsRes = useListGeneralContracts({
    ...sortFilterOptions,
    filters: {
      ...sortFilterOptions.filters,
      staged_for_review: true
    }
  });

  const loadingOrErrorUi = GenerateLoadingOrError([
    locationRes,
    marketZoneRes,
    customersResult,
    contractsRes,
    listTradersRes,
    stagedContractsRes,
  ]);

  if (loadingOrErrorUi) {
    return (
      <section className="flex min-h-full flex-1 flex-col justify-start px-6 py-6 lg:px-8">
        {loadingOrErrorUi}
      </section>
    );
  }

  const locations = locationRes.data?.data || [];
  const marketZones = marketZoneRes.data?.data || [];
  const customers = customersResult.data?.data || [];
  const contracts = contractsRes.data?.data || [];
  const stagedContracts = stagedContractsRes.data?.data || [];
  const traders = listTradersRes.data?.data || [];

  return (
    <GeneralContractContent
      showTitle={false}
      contracts={contracts}
      stagedContracts={stagedContracts}
      locations={locations}
      marketZones={marketZones}
      customers={customers}
      traders={traders}
    />
  );
}

